import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDg53OhKmBj-KHrZtctO0bEQ4NlFM4GoHA",
  authDomain: "babydaddywebsite.firebaseapp.com",
  projectId: "babydaddywebsite",
  storageBucket: "babydaddywebsite.firebasestorage.app",
  messagingSenderId: "1083674348958",
  appId: "1:1083674348958:web:92e084a135366801b79a8f",
  measurementId: "G-86EZK1RJRT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db, analytics };
